"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ripemd160 = void 0;
exports.ripemd160 = ripemd160;
const legacy_js_1 = require("@noble/hashes/legacy.js");
const utils_1 = require("./utils");
class Ripemd160 {
    blockSize = 512 / 8;
    impl = legacy_js_1.ripemd160.create();
    constructor(firstData) {
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update((0, utils_1.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
exports.Ripemd160 = Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */
function ripemd160(data) {
    return new Ripemd160(data).digest();
}
